import React from 'react';
import { Carousel } from 'antd';
import { makeStyles } from '@material-ui/core/styles';
import carousel01 from '../assets/carousel01.png';
import carousel02 from '../assets/carousel02.png';
import carousel03 from '../assets/carousel03.png';
import { MENU } from '../constants/index';

const useStyles = makeStyles(() => ({
  carousel: {
    
  },
  card: {
    width: '100%',
    position: 'relative'
  },
  img: {
    width: '100%',
    minHeight: 200,
    opacity: 0.9
  },
  text: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    color: '#fff',
    background: 'rgba(0, 0, 0, 0.3)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textL1: {
    fontSize: 80,
    '@media (max-width: 1260px)': {
      fontSize: '24px !important',
    },
  },
  textL2: {
    fontSize: 40,
    '@media (max-width: 1260px)': {
      fontSize: '13px !important',
    },
  },
  textL3: {
    '@media (max-width: 1260px)': {
      width: 86,
      height: 28,
      lineHeight: '28px',
      borderRadius: 6,
      marginTop: 8,
      color: '#6666c7',
      fontSize: '12px !important',
    },
    '&:hover': {
      background: '#fff',
    },
    width: 128,
    height: 46,
    lineHeight: '46px',
    textAlign: 'center',
    fontSize: 14,
    color: '#aaaaf1',
    borderRadius: 8,
    background: '#f0e8e8',
    cursor: 'pointer',
    marginTop: 50
  },
}));

const CarouselComponent: React.FC<{ setMenu: React.Dispatch<React.SetStateAction<string>> }> = ({ setMenu }) => {
  const classes = useStyles();

  return (
    <Carousel arrows autoplay infinite={true}>
      <div className={classes.card}>
        <img src={carousel01} className={classes.img} alt="" />
        <div className={classes.text}>
          <div className={classes.textL1}>专注知识产权服务</div>
          <div className={classes.textL2}>提供专利、商标、版权等知识产权代理服务，优质服务值得您信赖</div>
          <div className={classes.textL3} onClick={() => setMenu(MENU.service)}>了解更多</div>
        </div>
      </div>
      <div className={classes.card}>
        <img src={carousel02} className={classes.img} alt="" />
        <div className={classes.text}>
          <div className={classes.textL1}>知识产权服务，我们更专业</div>
          {/* <div className={classes.textL2}>代理案件1000+，服务客户800+</div> */}
          <div className={classes.textL3} onClick={() => setMenu(MENU.example)}>了解更多</div>
        </div>
      </div>
      <div className={classes.card}>
        <img src={carousel03} className={classes.img} alt="" />
        <div className={classes.text}>
          <div className={classes.textL1}>优质的服务团队</div>
          <div className={classes.textL2}>1对1沟通/本地上门服务/流程简单</div>
          <div className={classes.textL3} onClick={() => setMenu(MENU.consult)}>联系我们</div>
        </div>
      </div>
    </Carousel>
  );
};

export default CarouselComponent;